import React, { useState, useEffect } from 'react';
import { Button, Table, Thead, Tbody, Tr, Th, Td, chakra, Box, Icon, Image, Flex, Text, Center, background, Tooltip } from '@chakra-ui/react'

const ButtonStates = {
  0: {
    color: "#d62626",
    text: ""
  },
  1: {
    color: "#2ae252",
    text: "Aktiv"
  },
  'normal': {
    color: "#2ae252",
    text: "Aktiv"
  },
  'pending': {
    color: "#ffc320",
    text: "Auslogen"
  },
  'data': {
    color: "#d62626",
    text: ""
  },
  3: {
    color: "#aaa",
    text: ""
  },
  4: {
    color: "#aaa",
    text: ""
  },
  5: {
    color: "#aaa",
    text: ""
  }
}

export function ActivityButton(props) {

  return (
    <Tooltip label={ButtonStates[props.on]?.text} placement='top' hasArrow bg='#666' >
      <Button display='flex' justifyContent='center' alignItems='center'
        onClick={props.onClick} borderRadius={props.size / 2} padding={0}
        maxWidth={props.size} maxHeight={props.size} minWidth={props.size} minHeight={props.size}
        bgColor={ButtonStates[props.on]?.color} style={ButtonStyle} disabled={props.on == 0}
      >
        <Box style={shimmerstyle} width={props.size / 1.5} height={props.size / 1.5} borderRadius={props.size / 3} borderBottomWidth={props.size / 8} >
        </Box>

      </Button>
    </Tooltip>
  );
}

export function ActivityBulb(props) {
  return (
    <Tooltip label={ButtonStates[props.on]?.text} placement='top' hasArrow bg='#666' >
      <Box display='flex' justifyContent='center' alignItems='center'
        borderRadius={props.size / 2} padding={0}
        maxWidth={props.size} maxHeight={props.size} minWidth={props.size} minHeight={props.size}
        bgColor={ButtonStates[props.on]?.color} style={ButtonStyle}
      >
        <Box style={shimmerstyle} width={props.size / 1.5} height={props.size / 1.5} borderRadius={props.size / 3} borderBottomWidth={props.size / 8} ></Box>

      </Box>
    </Tooltip>
  );
}

const ButtonStyle = {
  border: '3px solid #222',
};
const shimmerstyle = {
  padding: '0px',
  margin: '0px',
  rotate: "-45deg"
};